<template>
  <v-container text-xs-center>
    <v-data-table
      :headers="headers"
      :items="
        resultsList.filter(
          item =>
            !newOnly ||
            (compareDate(item.resultDate) && item.athRankName != 'NA')
        )
      "
      :search="search"
      :sort-by="['props.item.firstName']"
      :footer-props="footerprops"
    >
      <template v-slot:item.athRankName="{ item }">
        <v-chip :color="`${item.rankColor}`">{{ item.athRankName }}</v-chip>
      </template>

      <template v-slot:item.resultDate="{ item }">
        <v-chip
          v-if="compareDate(item.resultDate) && item.athRankName != 'NA'"
          color="red"
          >{{ item.resultDate }}
          <v-icon> new_releases </v-icon>
        </v-chip>
        <v-chip v-else>{{ item.resultDate }} </v-chip>
      </template>

      <template v-slot:top>
        <!-- <BaseToolbar></BaseToolbar> -->
        <v-card>
          <v-card-title>
            Athlete Ranks
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex xs2 lg1>
                <v-select
                  v-model="gender"
                  @input="handleGetRanks()"
                  :items="['male', 'female']"
                  label="Gender"
                ></v-select>
              </v-flex>
              <v-flex xs2 lg1>
                <v-autocomplete
                  v-model="facilityType"
                  required
                  :hint="`${facilityType}`"
                  label="Select Facility Type"
                  @input="handleGetRanks()"
                  :items="['25m', '50m', '25y']"
                  item-value="facilityType"
                  item-text="facilityType"
                >
                </v-autocomplete>
              </v-flex>

              <v-divider class="mx-2" inset vertical></v-divider>

              <v-flex xs1 lg1>
                <v-checkbox
                  color="blue"
                  :label="$vuetify.breakpoint.mdAndUp ? 'Best' : ''"
                  :value="bestOnly"
                  v-model="bestOnly"
                  @change="handleGetRanks()"
                  hide-details
                >
                </v-checkbox>
              </v-flex>
              <v-flex xs1 lg1>
                <v-checkbox
                  color="red"
                  :label="$vuetify.breakpoint.mdAndUp ? 'New' : ''"
                  :value="newOnly"
                  v-model="newOnly"
                  @change="handleGetRanks()"
                  hide-details
                >
                </v-checkbox>
              </v-flex>
              <v-flex xs2 lg1>
                <v-autocomplete
                  v-model="daysOld"
                  required
                  hint="Only within defined period"
                  label="Days Old"
                  @input="handleGetRanks()"
                  :items="Array.from(Array(1000).keys())"
                >
                </v-autocomplete>
              </v-flex>
              <v-divider class="mx-2" inset vertical></v-divider>

              <v-flex xs2 lg2>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="handleGetRanks()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs2 lg2>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="handleGetRanks()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-divider class="mx-2" inset vertical></v-divider>

              <v-flex xs2 lg2>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import BaseToolbar from "../../base/BaseToolbar.vue";

export default {
  components: { BaseToolbar },
  data() {
    return {
      search: "",
      footerprops: {
        "items-per-page-options": [60, 90, 120, -1]
      },

      facilityType: "25m",
      bestOnly: true,
      newOnly: true,
      on: "",
      daysOld: 31,
      fromDate: "2017-03-13",
      toDate: new Date().toISOString().substr(0, 10),
      isMobile: false,
      menu: false,
      menu1: false,
      gender: null,
      pagination: {
        rowsPerPage: 15
      },
      headers: [
        {
          text: "NAME",
          align: "left",
          sortable: true,
          value: "firstName",
          class: ["column-color"]
        },
        { text: "RankName", value: "athRankName", class: ["column-color"] },
        { text: "Event", value: "distance", class: ["column-color"] },
        { text: "Stroke", value: "stroke", class: ["column-color"] },
        { text: "DATE", value: "resultDate", class: ["column-color"] },
        { text: "RESULT", value: "resultTime", class: ["column-color"] },
        {
          text: "Time To Next Rank",
          value: "timeToNextRank",
          class: ["column-color"]
        }
      ]
    };
  },
  created() {
    //Distructure URL i.e. this.$route.query
    //distructure from: http://localhost:8080/16/club/Ranks?gender&bestOnly=Y&daysOld=31&facilityType=50m&newOnly=Y

    if (!(Object.entries(this.$route.query).length === 0)) {
      const {
        gender,
        bestOnly,
        daysOld,
        facilityType,
        newOnly
      } = this.$route.query;
      //assign to current instance variables
      this.gender = gender;
      this.bestOnly = bestOnly;
      this.daysOld = parseInt(daysOld);
      this.facilityType = facilityType;
      this.newOnly = newOnly;
    }
    this.handleGetRanks();
  },
  mounted() {
    //
  },
  computed: {
    ...mapGetters(["loading", "resultsList", "rankLib"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    dialog() {
      return false;
    }
    // ,
    // fullQuery(){
    //  return "bestOnly=" + this.bestOnly+ ",daysOld=" + this.daysOld +",facilityType="+ this.facilityType +",newOnly="+ this.newOnly
    // }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    "$route.params.club": function() {
      this.$store.dispatch("allResultsList", {
        clubId: this.$route.params.club
      });
    }
    // user(value) {
    //
    //   //
    //   // if user value changes and redirect is populated - redirect to redirect page, otherwise to home lib page
    //
    // }
  },

  methods: {
    handleGetRanks() {
      // add query parameters to url
      // example: http://localhost:8080/16/club/Ranks?gender&bestOnly=Y&daysOld=31&facilityType=50m&newOnly=Y
      this.$router.replace({
        query: {
          gender: this.gender,
          bestOnly: this.bestOnly,
          daysOld: this.daysOld,
          facilityType: this.facilityType,
          newOnly: this.newOnly
        }
      });
      //this.$router.push(redir_path);
      //reach out of Vuex store, fire action that gets posts for carousel
      this.$store.dispatch("allResultsList", {
        gender: this.gender,
        tagSl: "CHAMPIONSHIP",
        clubId: this.$route.params.club,
        teamId: this.teamId,
        athleteId: this.athleteId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        facilityType: this.facilityType,
        bestOnly: this.bestOnly ? 1 : null,
        isNewDays: 130
      });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    compareDate: function(item) {
      return Math.abs((new Date() - new Date(item)) / 86400000) < this.daysOld;
      //return 1;
    }
  }
};
</script>
